export const HOME_HEALTH_CASES_PATH = "/home-health/cases";
export const HOME_HEALTH_CASE_MOBILE_DETAIL_PATH = "/home-health/cases/:caseId";

export function getHomeHealthCaseMobileDetailPath(caseId: string): string {
  return `/home-health/cases/${caseId}`;
}
